import { inject } from '@angular/core';
import { catchError, Observable, of, retry, switchMap } from 'rxjs';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { EnumCatalogueService } from 'src/app/shared/services/enum-catalogue/enum-catalogue.service';

/**
 * The app initializer: loads the signed-in user and, when there is one, the enum catalogue. A failed catalogue load is
 * retried once; if that fails too it is logged and marked on the catalogue (`loadFailed`), and the root component shows
 * the startup error instead of the app. Sign-in and the SSO return are full page loads, so the initializer runs again
 * once a user is signed in.
 */
export function initializeAppSession(): Observable<void> {
	const auth = inject(AuthService);
	const catalogue = inject(EnumCatalogueService);
	return auth
		.getUser({ skipAuthRedirect: true })
		.pipe(switchMap((user) => (user ? loadCatalogue(catalogue) : of(undefined))));
}

function loadCatalogue(catalogue: EnumCatalogueService): Observable<void> {
	return catalogue.load().pipe(
		retry(1),
		catchError((error: unknown) => {
			console.error('The enum catalogue failed to load', error);
			catalogue.markLoadFailed();
			return of(undefined);
		})
	);
}
